import React from 'react';
import propTypes from 'prop-types';

import format from 'date-fns/format';
import isToday from 'date-fns/is_today';
import isTomorrow from 'date-fns/is_tomorrow';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import { getLocaleTimeZone } from '../../utils/bootstrap-timezone';
import { getLocalizedDateFormat } from '~shared/utils/date-time';
import { DATE_TIME_FORMAT_HM } from '~shared/utils/constants';

// Time component displays time / date in any format you wish
// uses date-fns so you can have 24:00 or 11:00pm or Saturday 11:00pm - just pass in a format
const Time = props => {
    const today = isToday(props.dateTime) ? 'today' : null;
    const tomorrow = isTomorrow(props.dateTime) ? 'tomorrow' : null;

    const readableDate = today || tomorrow || distanceInWordsToNow(props.dateTime);

    return (
        <time dateTime={props.dateTime} readable-date={readableDate}>
            {format(new Date(props.dateTime), props.format, props.options)}
        </time>
    );
};

Time.propTypes = {
    dateTime: propTypes.oneOfType(
        [propTypes.string, propTypes.instanceOf(Date)]
    ),
    format: propTypes.string,
    options: propTypes.shape({
        locale: propTypes.object,
    }),
};

Time.defaultProps = {
    dateTime: new Date(),
    format: getLocalizedDateFormat(DATE_TIME_FORMAT_HM),
    options: {
        locale: getLocaleTimeZone(),
    },
};

export default Time;
